import { Form } from 'react-router'
import { useState } from 'react'
import { Donor } from '~/components/Donor'
import { Donation } from '~/components/Donation'
import { Message } from '~/components/Message'
import { Consent } from '~/components/Consent'
import { Contact } from '~/components/Contact'
import { SubmitTrigger } from '~/components/SubmitTrigger'
import { FormErrorProvider } from '~/components/FormContext'

export const RegistrationForm = ({ errors, registrationSource }) => {
  const [formId] = useState(() => crypto.randomUUID())
  const classNames = 'pt-0 mt-0 '
  return (
    <div className="rounded-b-lg bg-[#fafafa] xl:px-28">
      <FormErrorProvider errors={errors}>
        <Form method="post" className="">
          <input type="hidden" name="id" value={formId} />
          <input type="hidden" name="registrationSource" value={registrationSource} />
          <div className=" container mx-auto flex hidden max-w-screen-lg justify-center pb-4 print:block">
            <img src="images/sep-line.png" alt="line" className="h-2 w-full print:h-1" />
          </div>
          <div className={classNames}>
            <Donor formId={formId} />
          </div>
          <div className="print-break">
            <div className="container mx-auto flex max-w-screen-lg justify-center pb-4">
              <img src="images/sep-line.png" alt="line" className="h-2 w-full print:h-1" />
            </div>
            <div className={classNames}>
              <Donation />
              <Message />
            </div>
          </div>
          <div className="print-break">
            <div className="container mx-auto flex max-w-screen-lg justify-center pb-4">
              <img src="images/sep-line.png" alt="line" className="h-2 w-full print:h-1" />
            </div>
            <div className={classNames}>
              <Consent />
            </div>
          </div>
          <div className="flex justify-end py-4">
            <SubmitTrigger />
          </div>
        </Form>
      </FormErrorProvider>
      <div className="pb-6 pl-4">
        If you have questions about registering or changing your decision,&nbsp; <Contact />
      </div>
    </div>
  )
}
